import Icon from '../components/Icon.vue'

Icon.register({
  'suitcase-rolling': {
    width: 384,
    height: 512,
    paths: [
      {
        d: 'M336 160H48C21.5 160 0 181.5 0 208V432C0 458.5 21.5 480 48 480H64V496C64 504.8 71.2 512 80 512H112C120.8 512 128 504.8 128 496V480H256V496C256 504.8 263.2 512 272 512H304C312.8 512 320 504.8 320 496V480H336C362.5 480 384 458.5 384 432V208C384 181.5 362.5 160 336 160zM320 376C320 380.4 316.4 384 312 384H72C67.6 384 64 380.4 64 376V360C64 355.6 67.6 352 72 352H312C316.4 352 320 355.6 320 360V376zM320 280C320 284.4 316.4 288 312 288H72C67.6 288 64 284.4 64 280V264C64 259.6 67.6 256 72 256H312C316.4 256 320 259.6 320 264V280zM144 48H240V128H288V48C288 21.5 266.5 0 240 0H144C117.5 0 96 21.5 96 48V128H144V48z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/suitcase-rolling.js
// module id = vD1b
// module chunks = 144